module.exports = __webpack_public_path__ + "img/3x.74fbf35.jpg";